import { AfterViewInit, Component, EventEmitter, Inject, LOCALE_ID, PLATFORM_ID } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Subject, combineLatest, debounceTime, filter, take, takeUntil, timer } from 'rxjs';
import { FRONT_PAGE_EXPANSION_PANEL, FRONT_PAGE_GAMES_DESKTOP_QUERY } from 'src/app/apollo/front-page-games/front-page-games';
import { ExapnsionPanels, ExpansionPanelItem, FrontPageGamesResponse, GameCategory, GameItem } from 'src/app/apollo/models/base-models';
import { LICENCE } from 'src/app/global.tokens';
import { ClonerService } from 'src/app/services/utils/clone-object.service';
import { BaseComponent } from '../../base/base.component';
import { isPlatformServer } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { FilterGamesService } from 'src/app/services/utils/filter-games.service';
import { PaymentListService } from 'src/app/services/payment/methods/payment-list.service';
import { BonusListService } from 'src/app/services/payment/bonus/bonus-list.service';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { DialogClosePreviousUrl } from 'src/app/services/utils/dialog-close-previouse-url.service';
import { WINDOW } from '@ng-web-apis/common';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggedStatus } from 'src/app/services/auth/login/login.models';
import { SwiperConfig } from '../../games/search-game/search-game-swiper/search-game-swiper.component';
import { FrontPageGamesService } from 'src/app/services/page/front-games.service';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { gameInfoTrx } from 'src/app/router-translation.labels';
import { SwiperConfiguration } from '../../games/search-game/swiper-module/swiper-config.model';
import { SearchGameComponent } from '../../games/search-game/search-game.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-home-essentials',
  templateUrl: './home-essentials.component.html',
  styleUrls: ['./home-essentials.component.scss']
})
export class HomeEssentialsComponent extends BaseComponent implements AfterViewInit {
  categories: GameCategory[];
  operators: GameCategory[];
  isServer: boolean;
  isLogin: boolean;
  expansionPanel: ExpansionPanelItem[];
  isCampaignComp:boolean = true;
  isSearchbarVisible:boolean = false;

  constructor(
    private router: Router,
    private apollo: Apollo,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private cloneService: ClonerService,
    private filterGamesService: FilterGamesService,
    private paymentListService: PaymentListService,
    private bonusListService: BonusListService,
    private loginStatus: LoginStatusService,
    private prevUrlService: DialogClosePreviousUrl,
    private frontPageGamesService: FrontPageGamesService,
    protected translationConfig: TranslationConfig,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(LICENCE) public licence: string,
    @Inject(PLATFORM_ID) private platformId,
    @Inject(WINDOW) protected windowRef: Window,
    public route: ActivatedRoute
  ) {
    super();
  }
  ngAfterViewInit(): void {
    this.loginStatus.getIfUserLogged().pipe(take(1)).subscribe(resp => {
      this.isLogin = resp.isLogged === LoggedStatus.logged;
      combineLatest({
        // here pay list income
        paymentResp: this.paymentListService.fetchPayment(resp.fullInfo?.country || 'en').pipe(
          filter(resp => resp.length !== 0),
          take(1)),
        // here bonus list income
        // bonusResp: this.bonusListService.fetchData().pipe(
        //   filter(resp => resp.length !== 0),
        //   take(1))
      }
      ).subscribe((resp) => { })
    })
  }

  ngOnInit(): void {
    this.isServer = isPlatformServer(this.platformId);
    const query = FRONT_PAGE_GAMES_DESKTOP_QUERY;
    this.setSEOTags();
    this.apollo
      .watchQuery<ExapnsionPanels>({
        query: FRONT_PAGE_EXPANSION_PANEL,
        variables: {
          locale: this.locale,
          licenseName: this.licence
        }
      })
      .valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe((response) => {
        const expansionPanelResponse = response.data.expansionPanels.length > 1 ? response.data.expansionPanels.filter(item => item.licence !== 'all')[0] : response.data.expansionPanels[0];
        const resp: ExpansionPanelItem[] = this.cloneService.deepClone(expansionPanelResponse.item);
        this.expansionPanel = resp.map(item => {
          if (!!item && !!item.content) {
            item.content.safehtml = this.sanitizer.bypassSecurityTrustHtml(item.content.html);
            return item;
          }
        });
      });
    this.apollo
      .watchQuery<FrontPageGamesResponse>({
        query: query,
        variables: {
          locale: this.locale,
          licenseName: this.licence,
          countryName: [this.locale]
        }
      })
      .valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe((response) => {
        this.setSEOTags(response.data.pagesCategories[0]?.seo?.metaTitle, response.data.pagesCategories[0]?.seo?.metaDescription);

        this.categories = this.filterGamesService.filterCategories(response.data.pagesCategories[0]?.categories);

        this.operators = response.data.operators[0]?.categories;

        this.categories = this.categories.map(category => {

          let newCategory: GameCategory = this.cloneService.deepClone(category);
          newCategory.game = category.game.map(game => {
            let newGame: any = this.cloneService.deepClone(game);
            newGame.thumbnailDesktopRectangular = game.thumbnailDesktopRectangular || game.thumbnailDesktop;
            newGame.thumbnailDesktopSquare = game.thumbnailDesktopSquare || game.thumbnailDesktop;
            // let extendedGame = { thumbnailDesktopRectangle: thumbnailDesktopRectangle, thumbnailDesktopSquare: thumbnailDesktopSquare, ...game }

            return newGame;
          })
          return newCategory;
        });

        timer(100).pipe(take(1)).subscribe(() => {
          this.prevUrlService.getUrl().pipe(take(1)).subscribe(path => {
            if (path?.length == 1) {
              window.scrollTo(0, this.prevUrlService.getScrollPosition())
            }
          })
        })

        // if (isPlatformServer(this.platformId)) {
        //   this.categories = this.categories.slice(0, 1);
        // }
        // this.loadingService.hide();
      });

  }

  onGameClick(game: any) {
    this.router.navigate(["", this.translationConfig.getTranslation(gameInfoTrx), game.systemName]);
    //console.log('onGameClick game =>', game)
  }

  openSearchDialog(): void {
    const dialogRef = this.dialog.open(SearchGameComponent, {
      width: '646px',
      height: '80vh',
      backdropClass: 'search-blur-backdrop',
      panelClass: ['transparent', 'search-wrapper']
    });
  }

  CampaignVisibleComp(data:boolean) {
    this.isCampaignComp = data;
  }

  searchbarVisible(event) {
   this.isSearchbarVisible = event;
  }
}
